// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-group {
	padding: 16px;
}

.action-group .action-group-header {
	font-size: 21px;
	font-weight: bold;
	padding-bottom: 16px;
}

.action-group .action {
	height: 44px;
	font-size: 17px;
	color: #4483C8;
	line-height: 44px;
	border-bottom: solid 1px #ECECEC;
	cursor: pointer;
	position: relative;
}

.action-group .action:last-child {
	border-bottom: 0;
}

.action-group .action .fa {
	position: absolute;
	line-height: 44px;
	right: 0;
	top: 0;
	font-size: 21px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/ActionGroup.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,QAAQ;CACR,MAAM;CACN,eAAe;AAChB","sourcesContent":[".action-group {\n\tpadding: 16px;\n}\n\n.action-group .action-group-header {\n\tfont-size: 21px;\n\tfont-weight: bold;\n\tpadding-bottom: 16px;\n}\n\n.action-group .action {\n\theight: 44px;\n\tfont-size: 17px;\n\tcolor: #4483C8;\n\tline-height: 44px;\n\tborder-bottom: solid 1px #ECECEC;\n\tcursor: pointer;\n\tposition: relative;\n}\n\n.action-group .action:last-child {\n\tborder-bottom: 0;\n}\n\n.action-group .action .fa {\n\tposition: absolute;\n\tline-height: 44px;\n\tright: 0;\n\ttop: 0;\n\tfont-size: 21px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
